import React from 'react';
import PropTypes from 'prop-types';

export default function Radio(props) {
  let { label, style, ...args } = props;
  return (
    <label className='km__c--radio' style={style}>
      {label}
      <input type='radio' {...args} />
      <span className='km__c--radio-checkmark'></span>
    </label>
  );
}
Radio.propTypes = {
  label: PropTypes.string,
};
